import {
	Box, Card, Stack,
} from '@chakra-ui/react';
import React from 'react';
import {
	MdOutlineLocationOn,
	MdOutlineAccountBalanceWallet,
} from 'react-icons/md';

import {
	IconLabel, NextImageWrapper, Image,
} from '@/modules/shared';

type CompanyCardFeaturedProps = {
	job: {
		companyName: string
		image:       Image
		location:    string
		salary:      string
		title:       string
	}
};

export const CompanyCardFeatured = ({ job }: CompanyCardFeaturedProps) => {
	return (
		<Card.Root bg="#F8F8F8" p={0}>
			<Card.Header p={2} pb={0}>
				<Box bg="white" borderRadius="lg" w="100%">
					<NextImageWrapper
						aspectRatio="portrait"
						image={job.image}
						mx="auto"
						objectFit="contain"
						w="80%"
					/>
				</Box>
			</Card.Header>
			<Card.Body
				as={Stack}
				bg="#F8F8F8"
				gap={3}
				p={4}
			>
				<Stack gap={0}>
					<Card.Title>
						{job.companyName}
					</Card.Title>
					<Card.Description>
						{job.title}
					</Card.Description>
				</Stack>
				<IconLabel icon={MdOutlineLocationOn} label={job.location} variant="featured" />
				<IconLabel icon={MdOutlineAccountBalanceWallet} label={job.salary} variant="featured" />
			</Card.Body>
		</Card.Root>
	);
};
